import React from 'react'

export const FormRow = ({children, ...props}) => {
	const childrenAmt = React.Children.toArray(children).length
	const columns = '1fr '.repeat(childrenAmt).trimEnd()

	return (
		<div {...props} style={{'--columns': columns}} className="eitje-form-3-row">
			{children}
		</div>
	)
}
